import type { ReactNode } from "react";

import s from "./BaseButton.module.css";

type ButtonClassNameParams = {
    disabled?: boolean;
    className?: string;
    contentAlign?: ButtonContentAlign;
};

type ButtonContentProps = {
    icon?: string;
    showArrow?: boolean;
    children?: ReactNode;
};

export type ButtonContentAlign = "left" | "center";

export function getButtonClassName({ disabled, className, contentAlign = "left" }: ButtonClassNameParams) {
    return [
        s.button,
        contentAlign === "center" ? s.center : s.left,
        disabled ? `${s.disabled} disabled` : "",
        className || "",
    ].filter(Boolean).join(" ");
}

export function ButtonContent({ icon, showArrow = true, children }: ButtonContentProps) {
    const iconUrl = icon?.endsWith(".svg")
        ? icon.startsWith("/")
            ? icon
            : `/svg/${icon}`
        : "";

    return (
        <>
            {iconUrl ? (
                <span className={s.iconFrame} aria-hidden="true">
                    <span
                        className={s.maskIcon}
                        style={{
                            WebkitMask: `url(${iconUrl}) center / contain no-repeat`,
                            mask: `url(${iconUrl}) center / contain no-repeat`,
                        }}
                    />
                </span>
            ) : icon ? (
                <span className={s.iconFrame} aria-hidden="true">
                    <svg className={s.icon}>
                        <use href={`#${icon}`}></use>
                    </svg>
                </span>
            ) : null}

            <span className={s.content}>{children}</span>
            {showArrow ? (
                <svg className={s.arrow} aria-hidden="true">
                    <use href="/svg/btn_arrow.svg#btn-arrow"></use>
                </svg>
            ) : null}
        </>
    );
}
